import { render } from "./CertificationTypeFilter.vue?vue&type=template&id=aeb7195e&ts=true"
import script from "./CertificationTypeFilter.ts?vue&type=script&lang=ts&external"
export * from "./CertificationTypeFilter.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__